import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ActionButton, Field, TextInput } from "../components/common";

export default function ResetPassword() {
  const { hash } = useLocation();
  return <ResetForm key={hash} token={new URLSearchParams(hash.slice(1)).get("token") || ""} />;
}

function ResetForm({ token }) {
  const { logout } = useAuth();
  const [password, setPassword] = useState(""), [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false), [done, setDone] = useState(false), [error, setError] = useState("");
  useEffect(() => {
    const meta = document.createElement("meta"); meta.name = "referrer"; meta.content = "no-referrer"; document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
  const submit = async (event) => {
    event.preventDefault(); if (busy) return;
    if (password !== confirmation) { setError("The passwords do not match."); return; }
    setBusy(true); setError("");
    try { await api.post("/auth/reset-password", { token, password }); await logout(); setDone(true); setPassword(""); setConfirmation(""); }
    catch (e) { setError(errMsg(e)); }
    finally { setBusy(false); }
  };
  return <main className="min-h-screen bg-background tactical-grid px-5 py-14 sm:py-20" data-testid="reset-password-page">
    <section className="max-w-lg mx-auto rounded-xl border border-slate-300 bg-white p-6 sm:p-9 space-y-5">
      <p className="font-heading text-lg font-bold text-[#84252F]" data-testid="reset-password-brand">WELL FLEET LOGIC</p>
      <h1 className="font-heading text-4xl font-bold" data-testid="reset-password-heading">Set your password</h1>
      {done ? <p role="status" data-testid="reset-password-success" className="text-emerald-700">Your password has been updated. Previous sessions have been signed out.</p> : !token ? <p data-testid="reset-password-missing-token" role="alert" className="text-red-700">This link is incomplete. Request a new password-reset email.</p> : <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
        <Field label="New password"><TextInput testId="reset-password-new" type="password" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} required minLength={8} maxLength={72} disabled={busy} /></Field>
        <Field label="Confirm password"><TextInput testId="reset-password-confirm" type="password" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} required minLength={8} maxLength={72} disabled={busy} /></Field>
        <p data-testid="reset-password-help" className="text-xs text-slate-500">At least 8 characters. This link can be used only once.</p>
        {error && <p role="alert" data-testid="reset-password-error" className="text-red-700 text-sm break-words">{error}</p>}
        <ActionButton testId="reset-password-submit" type="submit" disabled={busy} className="w-full justify-center">{busy ? "Saving…" : "Save New Password"}</ActionButton>
      </form>}
      <Link to="/login" data-testid="reset-password-login" className="inline-block text-sm text-[#84252F] underline underline-offset-4">Back to Sign In</Link>
    </section>
  </main>;
}
